import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { translationsApi } from '@/api/translations.api';
import i18next from '@/i18n';
import { Languages } from '@/shared/constants';

export const useTranslationsLoader = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    const apiLanguage = i18n.language === Languages.en ? 'eng' : i18n.language;

    const loadAndSetTranslations = async () => {
      try {
        const response =
          await translationsApi.getOnlineTranslations(apiLanguage);

        if (response?.data) {
          i18next.addResourceBundle(
            i18n.language,
            'translation',
            response.data,
            true,
            true
          );

          await i18next.reloadResources();
          await i18next.changeLanguage(i18n.language);
        }
      } catch (error) {
        console.error('Failed to load translations:', error);
      }
    };

    loadAndSetTranslations();
  }, [i18n.language]);
};
